import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'cutString',
    standalone: true
})
export class CutStringPipe implements PipeTransform {

    transform(str: string, length: number = 50): string {
        if (!str) return '';
        if (str.length < length) return str;

        return str.slice(0, length).concat('...');
    }

}
